import AddIcon from '@mui/icons-material/Add';
import CloseIcon from '@mui/icons-material/Close';
import EmailIcon from '@mui/icons-material/Email';
import { DialogActions, DialogContent, DialogTitle } from '@mui/material';
import React, { useEffect, useState } from 'react';
import { useTranslation } from 'react-i18next';
import { toast } from 'react-toastify';
import UserData from '../../../assets/data/UserData';
import qr_code from '../../../assets/images/content/register-devices-qr.png';
import CopyIcon16pxSvg from '../../../assets/images/icons/CopyIcon16pxSvg';
import EmployeeGroupIcon45pxSvg from '../../../assets/images/icons/EmployeeGroupIcon45pxSvg';
import EmployeeIcon45pxSvg from '../../../assets/images/icons/EmployeeIcon45pxSvg';
import download_on_the_appstore from '../../../assets/images/logo/app-store.png';
import download_for_window from '../../../assets/images/logo/download-for-windows.png';
import get_it_on_google from '../../../assets/images/logo/get-it-on-googleplay.png';
import CustomAutocomplete from '../../../components/CustomAutocomplete';
import {
   ControlpanelErrorButton,
   ControlpanelSecondaryButton,
   ControlpanelSuccessButton,
   ControlpanelWarningButton,
   GrayIconButton,
} from '../../../components/StyledButton';
import { CustomDialog } from '../../../components/StyledComponents';
import { StyledLinkBlue } from '../../../components/StyledLink';
import SendTokenByEmailDialog from '../UserManagement/SendTokenByEmailDialog';
import { USER_GROUP } from './../../../assets/data/UserGroupsData';
import QuestionIcon16pxSvg from './../../../assets/images/icons/QuestionIcon16pxSvg';
import DefaultTooltip from './../../../components/DefaultTooltip';

const userGroupData = USER_GROUP;

const GenerateANewDeviceRegistrationTokenDialog = (props) => {
   const { t } = useTranslation();
   const handleCloseDialog = () => {
      setActiveStatus('begin');
      props.handleClose();
   };

   const [activeStatus, setActiveStatus] = useState(props.activeStatus);

   const handleButtonClick = (status) => {
      setActiveStatus(status);
   };

   useEffect(() => {
      setActiveStatus(props.activeStatus);
   }, [props.open]);

   const [formData, setFormData] = useState({
      employee: '',
      group: '',
   });

   const userData = UserData();

   const handleDataChange = (name, newData) => {
      setFormData((prevData) => ({
         ...prevData,
         [name]: newData,
      }));
   };

   const [employeeGenerated, setEmployeeGenerated] = useState(false);

   const handleEmployeeGenerate = () => {
      setEmployeeGenerated(true);
   };

   const handleRemoveEmployeeGenerate = () => {
      setEmployeeGenerated(false);
   };

   const [groupGenerated, setGroupGenerated] = useState(false);

   const handleGroupGenerate = () => {
      setGroupGenerated(true);
   };

   const handleRemoveGroupGenerate = () => {
      setGroupGenerated(false);
   };

   const [copyValue, setCopyValue] = useState('5770276');

   const handleCopyToClipboard = () => {
      navigator.clipboard
         .writeText(copyValue)
         .then(() => {
            toast.success('Copied to clipboard!');
            setTimeout(() => {}, 1500);
         })
         .catch((error) => {
            toast.error(error);
         });
   };

   const [openEmployeeSendByMail, setOpenEmployeeSendByMail] = useState(false);

   const handleOpenEmployeeSendByMail = () => {
      setOpenEmployeeSendByMail(true);
   };

   const handleCloseEmployeeSendByMail = () => {
      setOpenEmployeeSendByMail(false);
   };

   const [openGroupSendByMail, setOpenGroupSendByMail] = useState(false);

   const handleOpenGroupSendByMail = () => {
      setOpenGroupSendByMail(true);
   };

   const handleCloseGroupSendByMail = () => {
      setOpenGroupSendByMail(false);
   };

   return (
      <div>
         <CustomDialog maxWidth={'xl'} open={props.open} onClose={handleCloseDialog} keepMounted>
            <DialogTitle>
               <div className='flex justify-between'>
                  <div className='flex items-center gap-4'>
                     <p className='text-xl font-semibold '>{t('common.generate-a-new-device-registration-token')}</p>
                     <DefaultTooltip
                        readMore={true}
                        title={t('tool-tip.client-registering-view')}
                        content={
                           <div className='flex flex-col gap-3'>
                              <p>{t('tool-tip.before-record-attendances-in-checkid-facialsense')}.</p>
                           </div>
                        }
                     >
                        <QuestionIcon16pxSvg className='fill-[#BDBDBD]' />
                     </DefaultTooltip>
                  </div>
                  <GrayIconButton onClick={handleCloseDialog}>
                     <CloseIcon />
                  </GrayIconButton>
               </div>
            </DialogTitle>
            <DialogContent>
               {activeStatus === 'begin' && (
                  <div className='pt-3'>
                     <p>{t('common.select-the-type-of-registration-to-continue')}.</p>
                     <div className='pt-5 flex justify-center xl:justify-between md:px-20 flex-wrap gap-5'>
                        <div
                           className='card flex justify-center items-center p-5 cursor-pointer w-[300px]'
                           onClick={() => handleButtonClick('employee')}
                        >
                           <div className='flex flex-col gap-3 items-center'>
                              <div className='bg-[#5B93FF] rounded-full w-20 h-20 bg-opacity-10 flex justify-center items-center text-[#357EEB]'>
                                 <EmployeeIcon45pxSvg />
                              </div>
                              <p className='text-2xl font-semibold'>{t('common.employee')}</p>
                           </div>
                        </div>
                        <div
                           className='card flex justify-center items-center p-5 cursor-pointer w-[300px]'
                           onClick={() => handleButtonClick('group')}
                        >
                           <div className='flex flex-col gap-3 items-center'>
                              <div className='bg-[#5B93FF] rounded-full w-20 h-20 bg-opacity-10 flex justify-center items-center text-[#357EEB]'>
                                 <EmployeeGroupIcon45pxSvg />
                              </div>
                              <p className='text-2xl font-semibold'>{t('common.group')}</p>
                           </div>
                        </div>
                     </div>
                  </div>
               )}
               {activeStatus === 'employee' && (
                  <div className='employee-generate pt-3'>
                     <p>{t('common.generate-a-registration-code-below-and-use-it-to-register-any-of')}.</p>
                     <div className='pt-5 grid grid-cols-6 items-center'>
                        <div className='col-span-2'>
                           <p>{t('common.employee')}</p>
                        </div>
                        <div className='col-span-4'>
                           <div className='w-full'>
                              <CustomAutocomplete
                                 name='selectEmployee'
                                 options={userData}
                                 freeSolo={true}
                                 placeholder='Type to search user'
                                 dataType='user'
                                 onDataChange={handleDataChange}
                                 buttonColor='gray'
                                 // disabledValues={selectedValues}
                              />
                           </div>
                        </div>
                     </div>
                     <div className='pt-5'>
                        {employeeGenerated ? (
                           <div>
                              <div className='p-4 rounded-md bg-[#EFF6FF]'>
                                 <p>{t('common.use-email-function-to-send-this-registration')}</p>
                              </div>
                              <div className='pt-5 flex flex-col items-center'>
                                 <p>{t('common.one-time-registration-token')}</p>
                                 <div className='card !bg-[#EFF6FF] p-5 mt-3 text-center max-w-[250px]'>
                                    <p>{copyValue}</p>
                                    <StyledLinkBlue className='flex gap-2 cursor-pointer justify-center' onClick={handleCopyToClipboard}>
                                       <CopyIcon16pxSvg />
                                       {t('common.copy-to-clipboard')}
                                    </StyledLinkBlue>
                                    <p>{t('common.token-will-be-valid-until')} 2024-02-26 09:49 AM</p>
                                 </div>
                              </div>
                              <div className='pt-3 flex justify-center'>
                                 <img src={qr_code} alt='' className='img-responsive' />
                              </div>
                              <div className='flex gap-3 justify-end pt-3'>
                                 <ControlpanelErrorButton onClick={handleRemoveEmployeeGenerate}>
                                    <CloseIcon />
                                    <p>{t('button.remove')}</p>
                                 </ControlpanelErrorButton>
                                 <ControlpanelWarningButton onClick={handleOpenEmployeeSendByMail}>
                                    <EmailIcon />
                                    <p>{t('button.email')}</p>
                                 </ControlpanelWarningButton>
                              </div>
                           </div>
                        ) : (
                           <div className='flex justify-end'>
                              <ControlpanelSuccessButton onClick={handleEmployeeGenerate}>
                                 <AddIcon />
                                 <p>{t('button.generate')}</p>
                              </ControlpanelSuccessButton>
                           </div>
                        )}
                     </div>
                     <div className='pt-5'>
                        <p className='text-center'>CheckID FacialSense Lite clients</p>
                        <div className='flex flex-wrap items-center justify-center gap-5'>
                           <img src={get_it_on_google} alt='get_it_on_google' className='w-[150px]' />
                           <img src={download_for_window} alt='download_for_window' className='w-[150px]' />
                           <img src={download_on_the_appstore} alt='download_on_appstore' className='w-[150px]' />
                        </div>
                     </div>
                  </div>
               )}
               {activeStatus === 'group' && (
                  <div className='group-generate pt-3'>
                     <p>{t('common.generate-a-registration-code-below-and-use-it-to-register-any-of')}.</p>
                     <div className='pt-5 grid grid-cols-6 items-center'>
                        <div className='col-span-2'>
                           <p>{t('common.group')}</p>
                        </div>
                        <div className='col-span-4'>
                           <div className='w-full'>
                              <CustomAutocomplete
                                 name='selectGroupEmployee'
                                 options={userGroupData}
                                 freeSolo={true}
                                 placeholder='Type to search group'
                                 dataType='userGroup'
                                 onDataChange={handleDataChange}
                                 buttonColor='gray'
                                 // disabledValues={selectedValues}
                              />
                           </div>
                        </div>
                     </div>
                     <div className='pt-5'>
                        {groupGenerated ? (
                           <div>
                              <div className='p-4 rounded-md bg-[#EFF6FF]'>
                                 <p>{t('common.use-email-function-to-send-this-registration')}</p>
                              </div>
                              <div className='pt-5 flex flex-col items-center'>
                                 <p>{t('common.one-time-registration-token')}</p>
                                 <div className='card !bg-[#EFF6FF] p-5 mt-3 text-center max-w-[250px]'>
                                    <p>{copyValue}</p>
                                    <StyledLinkBlue className='flex gap-2 cursor-pointer justify-center' onClick={handleCopyToClipboard}>
                                       <CopyIcon16pxSvg />
                                       {t('common.copy-to-clipboard')}
                                    </StyledLinkBlue>
                                    <p>{t('common.token-will-be-valid-until')} 2024-02-26 09:49 AM</p>
                                 </div>
                              </div>
                              <div className='pt-3 flex justify-center'>
                                 <img src={qr_code} alt='' className='img-responsive' />
                              </div>
                              <div className='flex gap-3 justify-end pt-3'>
                                 <ControlpanelErrorButton onClick={handleRemoveGroupGenerate}>
                                    <CloseIcon />
                                    <p>{t('button.remove')}</p>
                                 </ControlpanelErrorButton>
                                 <ControlpanelWarningButton onClick={handleOpenGroupSendByMail}>
                                    <EmailIcon />
                                    <p>{t('button.email')}</p>
                                 </ControlpanelWarningButton>
                              </div>
                           </div>
                        ) : (
                           <div className='flex justify-end'>
                              <ControlpanelSuccessButton onClick={handleGroupGenerate}>
                                 <AddIcon />
                                 <p>{t('button.generate')}</p>
                              </ControlpanelSuccessButton>
                           </div>
                        )}
                     </div>
                     <div className='pt-5'>
                        <p className='text-center'>CheckID FacialSense Lite clients</p>
                        <div className='flex flex-wrap items-center justify-center gap-5'>
                           <img src={get_it_on_google} alt='get_it_on_google' className='w-[150px]' />
                           <img src={download_for_window} alt='download_for_window' className='w-[150px]' />
                           <img src={download_on_the_appstore} alt='download_on_appstore' className='w-[150px]' />
                        </div>
                     </div>
                  </div>
               )}
            </DialogContent>
            <DialogActions>
               <div className='flex gap-2 px-4 py-4'>
                  <ControlpanelSecondaryButton onClick={handleCloseDialog}>
                     <CloseIcon />
                     <p>{t('button.close')}</p>
                  </ControlpanelSecondaryButton>
               </div>
            </DialogActions>
         </CustomDialog>
         {openEmployeeSendByMail && <SendTokenByEmailDialog onClose={handleCloseEmployeeSendByMail} />}
         {openGroupSendByMail && <SendTokenByEmailDialog onClose={handleCloseGroupSendByMail} />}
      </div>
   );
};

export default GenerateANewDeviceRegistrationTokenDialog;
